// @flow

// TODO use something native for RN
const crypto = require('crypto-js/hmac-sha256');

export const signPayload = (secret: string = '', payload: string = '') =>
  Promise.resolve(crypto(payload, secret).toString());
